'use client';
import { LocaleCode } from '../../core/translation';
import './LocalizedFieldset.css';
import { createContext, ReactNode, useState } from 'react';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip/index.js';

interface LocalizedFieldsetContext {
	language: LocaleCode;
}

const localizedFieldsetContext = createContext<LocalizedFieldsetContext | undefined>(undefined);

interface LocalizedFieldsetProps {
	initialLanguage: LocaleCode;
	t?: any;
	children: ReactNode;
}

const LocalizedFieldset = ({ initialLanguage, t, children }: LocalizedFieldsetProps) => {
	const [language, setLanguage] = useState<LocaleCode>(initialLanguage);

	const onSelectLanguange = (lang: LocaleCode) => {
		setLanguage(lang);
	};

	const onTooltipAfterHide = (e: any) => {
		// Prevent the 'sl-hide' event from bubbling up. This is
		// necessary to prevent the unexpected hiding of the parent
		// elements such as drawers, dialog etc.
		e.stopPropagation();
	};

	return (
		<div className='localized-fieldset'>
			<div className='localized-field__flags'>
				<div
					className={`localized-field__flag${
						language === 'it' ? ' localized-field__flag--selected' : ''
					}`}
					onClick={() => onSelectLanguange('it')}
				>
					<SlTooltip
						content={t == null ? 'Italiano' : t('Italian')}
						hoist
						onSlAfterHide={onTooltipAfterHide}
					>
						<img src='/assets/italy.svg' />
					</SlTooltip>
				</div>
				<div
					className={`localized-field__flag${
						language === 'en' ? ' localized-field__flag--selected' : ''
					}`}
					onClick={() => onSelectLanguange('en')}
				>
					<SlTooltip
						content={t == null ? 'Inglese' : t('English')}
						hoist
						onSlAfterHide={onTooltipAfterHide}
					>
						<img src={'/assets/united-kingdom.svg'} />
					</SlTooltip>
				</div>
				<div
					className={`localized-field__flag${
						language === 'fr' ? ' localized-field__flag--selected' : ''
					}`}
					onClick={() => onSelectLanguange('fr')}
				>
					<SlTooltip
						content={t == null ? 'Francese' : t('French')}
						hoist
						onSlAfterHide={onTooltipAfterHide}
					>
						<img src={'/assets/france.svg'} />
					</SlTooltip>
				</div>
			</div>
			<localizedFieldsetContext.Provider value={{ language: language }}>
				{children}
			</localizedFieldsetContext.Provider>
		</div>
	);
};

export { LocalizedFieldset, localizedFieldsetContext };
